import { Component, computed, input, output } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { BillingPaymentMethod } from '../../../../../../../Interfaces/api/billing.interface';
import { BILLING_CARD_BRAND_FALLBACK, BILLING_CARD_BRAND_FILES } from '../../../../../../../Consts/billing.const';

@Component({
    selector: 'app-billing-payment-method-card',
    standalone: true,
    imports: [COMMON_IMPORTS],
    templateUrl: './payment-method-card.component.html',
    styleUrls: ['../../billing.scss'],
})
export class BillingPaymentMethodCardComponent {
    readonly paymentMethod = input<BillingPaymentMethod | null>(null);
    readonly billingContact = input<string | null>(null);
    readonly isReadOnly = input<boolean>(false);
    readonly isLoading = input<boolean>(false);

    readonly changeCard = output<void>();
    readonly changeContact = output<void>();

    readonly hasPaymentMethod = computed<boolean>(() => this.paymentMethod()?.has_payment_method === true);
    readonly hasCardDetails = computed<boolean>(() => this.paymentMethod()?.last4 != null);

    readonly cardParams = computed<Record<string, string>>(() => ({
        last4: this.paymentMethod()?.last4 ?? '',
    }));

    readonly expiryParams = computed<Record<string, string>>(() => ({
        month: String(this.paymentMethod()?.exp_month ?? ''),
        year: String(this.paymentMethod()?.exp_year ?? ''),
    }));

    readonly brandLabel = computed<string>(() => this.paymentMethod()?.brand ?? '');

    readonly brandAltParams = computed<Record<string, string>>(() => ({
        brand: this.brandLabel(),
    }));

    readonly brandSource = computed<string>(() => {
        const brand = (this.paymentMethod()?.brand ?? '').toLowerCase().replace(/[\s-]+/g, '_');
        return `assets/icons/cards/${BILLING_CARD_BRAND_FILES[brand] ?? BILLING_CARD_BRAND_FALLBACK}`;
    });

    readonly isExpiringSoon = computed<boolean>(() => {
        const month = this.paymentMethod()?.exp_month;
        const year = this.paymentMethod()?.exp_year;

        if (!month || !year) {
            return false;
        }

        const expiry = new Date(year, month, 0, 23, 59, 59);
        const threshold = new Date();
        threshold.setDate(threshold.getDate() + 60);

        return expiry <= threshold;
    });
}
